const eboard = {
    president: {
        name: "Grace Ramirez",
        email: "president.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/President-2026.JPG"
    },
    research: {
        name: "Valerie Glen",
        email: "vpresearch.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPResearch.jpeg"
    },
    secretary: {
        name: "Ema Longoria",
        email: "secretary.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/Secretary-2026.JPG"
    },
    treasurer: {
        name: "Gabriel Zapata",
        email: "treasurer.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/Treasurer-2026.JPG"
    },
    marketing: {
        name: "Emma De Varona",
        email: "vpmarketing.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPMarketing-2026.JPG"
    },
    technology: {
        name: "Hector Borjas",
        email: "vptech.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPTech-2026.JPG"
    },
    corporate: {
        name: "Iulia Bianchi",
        email: "vpcorporate.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPCorporate-2026.JPG"
    },
    external: {
        name: "Juan Yarala",
        email: "vpexternal.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPexternal.jpeg"
    },
    internal: {
        name: "Angelina Lopez",
        email: "vpinternal.shpeuf@gmail.com",
        image: "https://shpeuf.s3.amazonaws.com/public/eboard/VPInternal-2026.JPG"
    },
    eboard: "https://shpeuf.s3.amazonaws.com/public/eboard/eboard",
    mini: "https://shpeuf.s3.amazonaws.com/public/eboard/eboardMini"
};

export const treasurerEmail = eboard.treasurer.email;

export default eboard;
